import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('@my-account/features');
